import { ECode } from '../../../repositories/billing-service-packages-balancer/v1/buy-package';
import { EAccountType } from '../../../redux/reducers';
import { EBuyPackageStatus } from '../../../reducers/types';

export function getPackageStatus(
  code: keyof typeof ECode,
  billingUserType?: EAccountType | undefined,
  transactionId?: string | undefined,
): EBuyPackageStatus {
  switch (true) {
    case code === EBuyPackageStatus.Ok:
      return EBuyPackageStatus.Ok;

    case code === EBuyPackageStatus.NotEnoughMoney: {
      if (billingUserType === 'natural' && transactionId) {
        return EBuyPackageStatus.NotEnoughMoneyWithDeposit;
      }

      return EBuyPackageStatus.NotEnoughMoney;
    }

    case code === EBuyPackageStatus.TariffNotAvailable:
      return EBuyPackageStatus.TariffNotAvailable;

    default:
      return EBuyPackageStatus.Error;
  }
}
